export default function ValueProposition() {
  return (
    <section className="w-full py-14 md:py-20 bg-accent-50/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
            {/* Left side - image with cutout feel */}
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20desk%20setup%20with%20a%20sleek%20laptop%20displaying%20colorful%20data%20charts%20and%20analytics%20dashboards%20on%20screen%2C%20surrounded%20by%20neatly%20arranged%20fabric%20swatches%20in%20warm%20terracotta%20and%20cream%20tones%2C%20a%20ceramic%20coffee%20cup%20and%20small%20potted%20succulent%20alongside%2C%20soft%20afternoon%20light%20streaming%20through%20linen%20curtains%2C%20editorial%20workspace%20photography%20with%20warm%20amber%20color%20palette%2C%20organic%20textures%20and%20refined%20composition&width=800&height=1000&seq=why-section-v3&orientation=portrait"
                  alt="ACBuySpreadsheet data tracking system in a modern minimalist workspace with warm ambient lighting"
                  title="Why ACBuySpreadsheet – Advanced Data Tracking Framework"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Floating trust badge */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-background-50 rounded-xl px-5 py-3 flex items-center gap-3">
                <div className="flex -space-x-2">
                  <div className="w-8 h-8 rounded-full bg-accent-300 border-2 border-background-50"></div>
                  <div className="w-8 h-8 rounded-full bg-primary-300 border-2 border-background-50"></div>
                  <div className="w-8 h-8 rounded-full bg-secondary-400 border-2 border-background-50"></div>
                  <div className="w-8 h-8 rounded-full bg-primary-500 border-2 border-background-50 flex items-center justify-center">
                    <span className="text-background-50 text-[10px] font-bold">+</span>
                  </div>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">Join 10,000+ users</p>
                  <p className="text-[10px] text-foreground-500 whitespace-nowrap">Trusted by data-driven teams</p>
                </div>
              </div>
            </div>

            {/* Right side - content */}
            <div>
              <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-wide mb-3">
                / WHY ACBUYSPREADSHEET
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
                Why ACBuySpreadsheet Is Becoming the <span className="text-primary-500">New Standard</span>
              </h2>

              <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                Most spreadsheet users struggle with disorganized tracking, lack of automation, and poor data visibility. The <strong>acbuyspreadsheet</strong> framework solves these challenges by providing structured systems, automation-ready templates, and performance dashboards that transform how you work with data.
              </p>

              <div className="space-y-4 mb-8">
                {[
                  { icon: "ri-dashboard-line", title: "Structured Spreadsheet Frameworks", desc: "Pre-built, scalable templates designed for real-world data tracking scenarios." },
                  { icon: "ri-flashlight-line", title: "Automation-Ready Tracking Systems", desc: "Eliminate repetitive manual entry with smart automation workflows built into the acbuyspreadsheet system." },
                  { icon: "ri-bar-chart-grouped-line", title: "Performance Comparison Dashboards", desc: "Visual insights and side-by-side comparisons to optimize your data decisions." },
                  { icon: "ri-stack-line", title: "Scalable Data Optimization Workflows", desc: "Grow from basic tracking to advanced multi-source data pipelines without rebuilding." },
                ].map((item) => (
                  <div key={item.title} className="flex gap-4 items-start">
                    <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-primary-100/70">
                      <i className={`${item.icon} text-primary-600 text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h4>
                      <p className="text-xs md:text-sm text-foreground-500 mt-1">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}